import { type UseQueryOptions, useQuery } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import type {
  GetStatisticsParams,
  LabStatisticsResponse,
} from 'types/api/labs/lab_trade_instances';
import { type ApiError, faksApiInstance as api } from './api';

export const useGetLabStatisticsQuery = (
  params?: GetStatisticsParams,
  options?: UseQueryOptions<LabStatisticsResponse, AxiosError<ApiError>>
) =>
  useQuery({
    queryKey: ['labs/trades_instances/statistics', params],
    queryFn: () => api.get<LabStatisticsResponse>('labs/trades_instances/statistics', { params }),
    enabled: !!params,
    ...options,
  });
